import React from "react"
import { Grid } from "@mui/material"

import { AppCardTitle, AppCrudTable, AppResultsSkeleton } from "@components"
import { acrissGroupData, isLoadingAcrissGroupData } from "Pages/OneWay/AcrissGroups/@signals"
import AcrissGroupsButton from "Pages/OneWay/AcrissGroups/Button"
import { acrissColumn, actionsColumn, nameColumn } from "./columns"


export default function AcrissGroupsTable() {
	if (isLoadingAcrissGroupData.value) return <Grid item xs={12}><AppResultsSkeleton rows={6} columns={3}/></Grid>

	return <Grid item xs={12}>
		<AppCrudTable
			options={{ customToolbar: () => <AcrissGroupsButton/> }}
			title={<AppCardTitle icon="layer-group" title="Your Acriss Groups"/>}
			data={acrissGroupData.value || []}
			columns={[
				nameColumn(),
				acrissColumn(),
				actionsColumn(),
			]}
		/>
	</Grid>
}
